var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.data)?_c('GradientLegend',{attrs:{"title":_vm.data.title,"colors":_vm.data.colors,"ticks":[_vm.$t('message.low'), _vm.$t('message.high')]}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }